// src/routes/index.jsx
import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';


// Pages publiques
import Accueil from '../pages/public/Accueil.jsx';  // ⭐ IMPORT AJOUTÉ
import Login from '../pages/Login.jsx';
import ForgotPassword from '../pages/ForgotPassword.jsx';
import ResetPassword from '../pages/ResetPassword.jsx';
import OAuthCallback from '../pages/OAuthCallback.jsx';
import InscriptionPublique from '../pages/public/InscriptionPublique.jsx';

// Composant de protection des routes
import ProtectedRoute from './ProtectedRoute';

// Layouts
import LayoutStaff from '../layouts/LayoutStaff.jsx';
import  LayoutEtudiant  from '../layouts/LayoutEtudiant.jsx';

// SuperAdmin
import DashboardSuperAdmin from '../pages/superadmin/DashboardSuperAdmin.jsx';
import MonitoringSystem from '../pages/superadmin/MonitoringSystem.jsx';
import AdminManager from '../pages/superadmin/AdminManager.jsx';
import SettingsLicence from '../pages/superadmin/config/SettingsLicence.jsx';

import AuditLogsSuper from '../pages/superadmin/config/AuditLogsSuper.jsx';
import MoteurConfigManager from '../pages/superadmin/config/MoteurConfigManager.jsx';
import MonitorMoteurManager from '../pages/superadmin/config/MonitorMoteurManager.jsx';
import SuperAdminBackupPanel from '../pages/superadmin/config/SuperAdminBackupPanel.jsx';

// Admin
import DashboardAdmin from '../pages/admin/DashboardAdmin.jsx';
import ClientManager from '../pages/admin/ClientManager.jsx';
import GestionFormationAdmin from '../pages/admin/GestionFormationAdmin.jsx';
import GestionEvaluationsAdmin from '../pages/admin/GestionEvaluationsAdmin.jsx';
import ConstruireJsonRichAdmin from '../pages/admin/ConstruireJsonRichAdmin.jsx';
import ConstruireJsonAdmin from '../pages/admin/ConstruireJsonAdmin.jsx';
import ConstruireEvaluation from '../pages/admin/ConstruireEvaluation.jsx';
import ConstruireEvaluationRich from '../pages/admin/ConstruireEvaluationRich.jsx';
import ReportingAdmin from '../pages/admin/ReportingAdmin.jsx';

// CLIENT 
import DashboardClient from '../pages/client/DashboardClient.jsx';
import EtudiantClient from '../pages/client/EtudiantClient.jsx';
import EvaluationsClient from '../pages/client/EvaluationsClient.jsx';
import EvaluationsRichClient from '../pages/client/EvaluationRichClient.jsx';
import InscriptionClient from '../pages/client/InscriptionClient.jsx';
import RapportClient from '../pages/client/RapportClient.jsx';
import ResultatsClient from '../pages/client/ResultatsClient.jsx';
import FormationEvaluation from '../pages/client/FormationEvaluation.jsx';
import CorrectionClient from '../pages/client/CorrectionClient.jsx';
// ETUDIANT 
import DashboardEtudiant from '../pages/etudiant/DashboardEtudiant.jsx';

// Pages additionnelles
import NotFound from '../pages/NotFound.jsx';


import { 
	FormationPdf, 
	FormationJson, 
	FormationJsonRich,
	FormationVideo, // ⭐ NOUVEAU
	Evaluation, 
	EvaluationRich, 
	Selector, 
    LecteurFormation,
	LecteurEvaluation ,
	LecteurEvaluationRich ,
	DemoViewer
} from './Exports.js';

// Mapping des rôles vers les layouts et composants
const roleConfig = {
    'ROLE_SUPERADMIN': {
        layout: LayoutStaff,
        defaultPath: '/superadmin/dashboard',
        routes: [
            { path: '/superadmin/dashboard', element: <DashboardSuperAdmin /> },
            { path: '/superadmin/admins', element: <AdminManager /> },
            { path: '/superadmin/config/moteurs', element: <MoteurConfigManager /> },
            { path: '/superadmin/moteur/monitor', element: <MonitorMoteurManager /> },
            { path: '/superadmin/monitoring', element: <MonitoringSystem /> },
            { path: '/superadmin/audit-logs', element: <AuditLogsSuper /> },
            { path: '/superadmin/config/licences', element: <SettingsLicence /> },
			{ path: '/superadmin/config/backup', element: <SuperAdminBackupPanel /> },
        ]
    },
    'ROLE_ADMIN': {
        layout: LayoutStaff,
        defaultPath: '/admin/dashboard',
        routes: [
            { path: '/admin/dashboard', element: <DashboardAdmin /> },
            { path: '/admin/clients', element: <ClientManager /> },
            { path: '/admin/formation', element: <GestionFormationAdmin /> },
			{ path: '/admin/evaluation', element: <GestionEvaluationsAdmin /> },
			{ path: '/admin/buildjson', element: <ConstruireJsonAdmin /> },
			{ path: '/admin/buildjsonrich', element: <ConstruireJsonRichAdmin /> },
			{ path: '/admin/buildeval', element: <ConstruireEvaluation /> },
			{ path: '/admin/buildevalrich', element: <ConstruireEvaluationRich /> },
			{ path: '/admin/reportadmin', element: <ReportingAdmin /> },
        ]
    },
    'ROLE_CLIENT': {
        layout: LayoutStaff,
        defaultPath: '/client/dashboard',
        layoutProps: { title: "Espace Client" },
        routes: [
            { path: '/client/dashboard', element: <DashboardClient /> },
			{  path: "/client/etudiant", element: <EtudiantClient />},
			{ path: "/client/inscription", element: <InscriptionClient />},
			{ path: "/client/evaluation", element: <EvaluationsClient />},
			{ path: "/client/evaluationrich", element: <EvaluationsRichClient />},
			{ path: "/client/correction", element: <CorrectionClient /> },
			{ path: "/client/resultat", element: <ResultatsClient /> },
			{ path: "/client/rapport", element: <RapportClient /> },
			{ path: "/client/formations/postdeman", element: <FormationEvaluation /> },
			
        ]
    },
	// Dans roleConfig pour ETUDIANT
	'ROLE_ETUDIANT': {
		layout: LayoutEtudiant,
	    defaultPath: '/etudiant/dashboard',
		layoutProps: { title: "Espace Etudiant" },
		routes: [
	        { path: '/etudiant/dashboard', element: <DashboardEtudiant /> },
	    ]
	}

};

// ⭐ Routes publiques (accessibles sans authentification)
const publicRoutes = [
	{ path: '/', element: <Accueil /> }, // ⭐ Page d'accueil publique
	{ path: '/accueil', element: <Accueil /> }, // ⭐ Alias
	{path: '/inscription', element: <InscriptionPublique />},
    { path: '/login', element: <Login /> },
    { path: '/login/oauth2/code/portail-client', element: <OAuthCallback /> },
    { path: '/mentions-legales', element: <div>Mentions légales</div> },
    { path: '/confidentialite', element: <div>Politique de confidentialité</div> },
    { path: '/forgot-password', element: <ForgotPassword /> },
    { path: '/reset-password', element: <ResetPassword /> },
    { path: '/demo', element: <DemoViewer /> }, // ⭐ Route Demo en public
	
];


export default function AppRoutes() {
   // console.log('🗺️ [ROUTES] AppRoutes monté');
   // console.log('🗺️ [ROUTES] Routes publiques:', publicRoutes.map(r => r.path));
    
    return (
        <Routes>
            {/* Routes publiques */}
            {publicRoutes.map((route, index) => (
                <Route key={`public-${index}`} path={route.path} element={route.element} />
            ))}

            {/* Routes protégées par rôle */}
            <Route path="/*" element={<ProtectedRoute roleConfig={roleConfig} />} />

            {/* Route 404 - Doit être en dernier */}
            <Route path="*" element={<NotFound />} />
        </Routes>
    );
}


export {
	FormationPdf,
	FormationJson,
	FormationJsonRich,
	FormationVideo, 
	Evaluation,
	EvaluationRich,
	Selector,
	LecteurFormation,
	LecteurEvaluation,
	LecteurEvaluationRich,
	DemoViewer
};